module.exports = __webpack_public_path__ + "img/cover-wwdc.b17e5929.jpg";